// Taxonomía unificada de tipos de servicio/reserva (legacy "Creador de Itinerarios" + Free Day).
// Usada por el Cotizador (CotServicio) y por las Reservas (Reserva).
export const SERVICE_TYPES = ["alojamiento", "actividad", "entradas", "transfer", "tren", "vuelo", "rental_car", "free_day"];

export const SERVICE_TYPE_LABELS = {
  alojamiento: "Alojamiento",
  actividad: "Actividad",
  entradas: "Entradas",
  transfer: "Transfer",
  tren: "Tren",
  vuelo: "Vuelo",
  rental_car: "Coche de alquiler",
  free_day: "Free Day",
};

// El coche de alquiler se factura por coche (capacidad 4-5 pax), no escala con el grupo:
// la cantidad la fija el agente manualmente.
export const isRentalCarType = (t) => t === "rental_car";

// Compatibilidad con el valor antiguo del SOFI 1.0
export const LEGACY_TYPE_ALIASES = { actividad_transporte: "actividad" };
export const normalizeServiceType = (t) => LEGACY_TYPE_ALIASES[t] || t || "actividad";

export const isLodgingType = (t) => t === "alojamiento";
export const isFreeType = (t) => t === "free_day";

// producto del catálogo -> tipo de servicio (taxonomía unificada).
// Tras la unificación, el catálogo ya usa la misma taxonomía; mantenemos alias por compat.
const PRODUCT_TYPE_ALIASES = {
  hotel: "alojamiento", accommodation: "alojamiento", lodging: "alojamiento",
  activity: "actividad", other: "actividad",
};
export const mapProductType = (pt, name = "") => {
  const t = PRODUCT_TYPE_ALIASES[pt] || pt || "actividad";
  if (t === "transfer") {
    const n = (name || "").toLowerCase();
    const isTransfer = n.includes("transfer") || n.includes("traslado");
    if (!isTransfer) {
      if (/\b(flight|vuelo)\b/.test(n)) return "vuelo";
      if (/\b(train|tren|rail|renfe|trenitalia|italo)\b/.test(n)) return "tren";
    }
  }
  return t;
};

// tipo de servicio -> tipo de producto del catálogo (para filtrar el buscador).
// Taxonomía unificada: es identidad (free_day no filtra catálogo).
export const serviceTypeToProductType = (t) => (t === "free_day" ? "" : (t || ""));
